import { create } from "zustand"

// Signals a PEER window's mutation just landed in this window's cache. Bumped only after
// `invalidateFromPeer`'s refetch resolves, so consumers see fresh data, not just a "changed" note.
// A monotonic counter, not a boolean, so each consumer tracks its own "last applied" value.
type Store = {
	peerUpdateEpoch: number
	bumpPeerUpdateEpoch: () => void
}

export const useQuotationPeerSyncStore = create<Store>((set) => ({
	peerUpdateEpoch: 0,
	bumpPeerUpdateEpoch: () => set((state) => ({ peerUpdateEpoch: state.peerUpdateEpoch + 1 })),
}))
